import { useGetCurrencyQuery } from "../services/public/location";
import { convertKWDToTarget, formatCurrency } from "../utils/currency";
import { useTranslation } from "react-i18next";

// Hook to provide centralized currency conversion and formatting.
export const useCurrency = () => {
  const { data: currencyData, isLoading: isCurrencyLoading } = useGetCurrencyQuery(undefined, { refetchOnMountOrArgChange: true });

  const { i18n } = useTranslation();

  const rate = currencyData?.rate || 1.0;
  const code = currencyData?.currency_code || "KWD";
  const locale = i18n.language === "ar" ? "ar-KW" : "en-KW";

  // Converts a KWD amount to the target currency and formats it.
  const convertAndFormat = (kwdAmount, hideSign = false) => {
    const converted = convertKWDToTarget(kwdAmount, rate);
    return formatCurrency(converted, code, locale, hideSign);
  };

  return {
    convertAndFormat,
    rate,
    code,
    symbol: currencyData?.currency_symbol || "KD",
    isLoading: isCurrencyLoading,
    currencyData,
  };
};
